<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">用户名称:</div>
                <el-input v-model="conditionData.Name" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">搜索</el-button>
                <el-button type="warning" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addDialogShow()">新建</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column
                type="selection"
                width="80"
                align="center"
                >
                </el-table-column>
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="mechanismName"
                label="机构名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="expertise"
                label="擅长领域"
                align="center"
                >
                </el-table-column>
                
                <el-table-column
                prop="enable"
                label="是否启用"
                align="center"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.enable">启用</span>
                    <span v-else>禁用</span>
                </template>
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="100px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="isUpdateDialogShow(scope.row)">编辑</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>


        <el-dialog :visible.sync="isAddDialog" title="新增" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        公估师名称:
                    </div>
                    <div class="input">
                        <el-input v-model="addData.name" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        机构:
                    </div>
                    <div class="input">
                        <el-input v-model="organization" size="small" placeholder="请选择"></el-input>
                        <el-button type="primary" size="small" @click="organizationDialog=true">选择机构</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        公估师文件:
                    </div>
                    <el-upload
                        :action="uploadUrl"
                        multiple
                        :before-upload="beforeUpload"
                        :show-file-list="false"
                        :http-request="uploadDataUpdate"
                        >
                        <el-button type="primary" size="small" class="uploadbtn">上传图片</el-button>
                    </el-upload>
                </div>
                <div class="imglist">
                    <div class="pics-item" v-for="(item,index) in piclist" :key='index'>
                        <el-image
                        class="img"
                        :src="item"
                        :preview-src-list="piclist">
                        </el-image>
                        <img src="../../../assets/images/icon08.png" mode="" class="close" @click="clearImg(index)"/>
                    </div>
                </div>
                
                <div class="item">
                    <div class="label">
                        擅长领域:
                    </div>
                    <div class="input">
                        <el-input v-model="addData.expertise" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        证件类型:
                    </div>
                    <div class="input">
                        <el-input v-model="addData.documentType" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        证件号码:
                    </div>
                    <div class="input">
                        <el-input v-model="addData.identiNumber" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        是否启用:
                    </div>
                    <el-select v-model="addData.enable" placeholder="请选择" size="small">
                        <el-option
                        v-for="item in enableList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="btns">
                    <el-button type="primary" icon="el-icon-check" size="small" @click="addAssessment">提交</el-button>
                </div>
            </div>
        </el-dialog>
        
        <el-dialog :visible.sync="isUpdateDialog" title="新增" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        公估师名称:
                    </div>
                    <div class="input">
                        <el-input v-model="updateData.name" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        机构:
                    </div>
                    <div class="input">
                        <el-input v-model="organization" size="small" placeholder="请选择"></el-input>
                        <el-button type="primary" size="small" @click="organizationDialog=true">选择机构</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        公估师文件:
                    </div>
                    <el-upload
                        :action="uploadUrl"
                        multiple
                        :before-upload="beforeUpload"
                        :show-file-list="false"
                        :http-request="uploadDataUpdate"
                        >
                        <el-button type="primary" size="small" class="uploadbtn">上传图片</el-button>
                    </el-upload>
                </div>
                <div class="imglist">
                    <div class="pics-item" v-for="(item,index) in piclist" :key='index'>
                        <el-image
                        class="img"
                        :src="item"
                        :preview-src-list="piclist">
                        </el-image>
                        <img src="../../../assets/images/icon08.png" mode="" class="close" @click="clearImg(index)"/>
                    </div>
                </div>
                
                <div class="item">
                    <div class="label">
                        擅长领域:
                    </div>
                    <div class="input">
                        <el-input v-model="updateData.expertise" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        证件类型:
                    </div>
                    <div class="input">
                        <el-input v-model="updateData.documentType" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        证件号码:
                    </div>
                    <div class="input">
                        <el-input v-model="updateData.identiNumber" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        是否启用:
                    </div>
                    <el-select v-model="updateData.enable" placeholder="请选择" size="small">
                        <el-option
                        v-for="item in enableList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="btns">
                    <el-button type="primary" icon="el-icon-check" size="small" @click="updateAssessment">提交</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="organizationDialog" title="机构选择" width="800px">
            <div class="table">
                <el-table
                    :data="organizationList"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    <el-table-column
                    prop="name"
                    label="机构名称"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="所属省份"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="city"
                    label="所属市级"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="area"
                    label="所属片区"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="操作"
                    width="120px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="selectOrganization(scope.row)">选择机构</el-button>
                    </template>
                    </el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination
                    @current-change="handleOrganizationPageChange"
                        background
                        layout="prev, pager, next"
                        :total="organizationTotalCount"
                        :current-page="organizationPage"
                        :page-size="organizationPageSize">
                    </el-pagination>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
export default {
    name: 'person',
    data () {
        return {
            uploadUrl:'http://txggpic.oss-cn-shenzhen.aliyuncs.com',
            enableList:[
                {
                    value:true,
                    label:'启用'
                },{
                    value:false,
                    label:'禁用'
                }
            ],
            isShow:false,
            totalCount:0,
            isUpdateDialog:false,
            updateData:{}, 
            conditionData:{
                Name:'',
                Phone:'',
                page:1,
                pageSize:10,
            },
            tableData:[],
            isAddDialog:false,
            addData:{
                ganden:2,
            },

            organization:'',
            organizationList:[],
            organizationPage:1,
            organizationPageSize:10,
            organizationDialog:false,
            organizationTotalCount:0,
            piclist:[],
        }
    },
    created(){

    },
    mounted(){
        this.loadingData();
        this.queryRole();
        this.queryOrganization();
    },
    methods:{
        
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async uploadDataUpdate(file){
            let res = await api.uploadOther(file.file);
            console.log(res);
            this.piclist.push(res);
            return;
        },
        async clearImg(index){
            this.piclist.splice(index,1)
        },
        async loadingData() {
            let res  = await api.QueryAssessor(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        selectRole(row){
            this.role = row.name
            this.roleDialog = false;
            if(this.isAddDialog){
                this.addData.roleId = row.id
            }else if(this.isUpdateDialog){
                this.updateData.roleId = row.id
            }
        },
        selectOrganization(row){
            console.log(row);
            this.organization = row.name
            this.organizationDialog = false;
            if(this.isAddDialog){
                this.addData.mechanismId = row.id
            }else if(this.isUpdateDialog){
                this.updateData.mechanismId = row.id
            }
        },
        handleRolePageChange(page){
            this.rolePage = page;
            this.queryRole();
        },
        handleOrganizationPageChange(page){
            this.organizationPage = page;
            this.queryOrganization();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        async isUpdateDialogShow(row){
            console.log(row);
            if(row.paths){
                this.piclist = row.paths.split(',')
            }else{
                this.piclist = [];
            }
            this.organization = row.mechanismName
            this.updateData = row;
            this.isUpdateDialog = true;
        },
        // 重置
        reset(){
            this.conditionData = {
                name:'',
                page: 1,
                pageSize: 10,
            },
            this.loadingData();
        },
        // 弹出新建
        addDialogShow(){
            console.log(this.paths);
            this.addData={};
            this.piclist = [];
            this.organization='';
            this.$forceUpdate();
            this.isAddDialog = true;
        },
        // 添加用户
        async addAssessment(){
            for(let index in this.piclist){
                if(index == 0){
                    this.addData.paths = this.piclist[index]
                }else{
                    this.addData.paths = this.addData.paths + ',' + this.piclist[index]
                }
            }
            let res  = await api.CreateAssessor(this.addData);
            if(res.data.code == '200'){
                this.isAddDialog = false;
                this.$message({
                    type: 'success',
                    message: '新增成功!'
                });
                this.selectData();
            }
        },
        // 更新
        async updateAssessment(){
            for(let index in this.piclist){
                if(index == 0){
                    this.updateData.paths = this.piclist[index]
                }else{
                    this.updateData.paths = this.updateData.paths + ',' + this.piclist[index]
                }
            }
            let res  = await api.UpdateAssessor(this.updateData);
            if(res.data.code == '200'){
                this.isUpdateDialog = false;
                this.$message({
                    type: 'success',
                    message: '更新成功!'
                });
                this.selectData();
            }
        },
        // 角色列表
        async queryRole(){
            let res  = await api.QueryRole({page:this.rolePage});
            console.log(res);
            this.roleList = res.data.data.data;
            this.roleTotalCount = res.data.data.totalCount;
        },
        // 机构列表
        async queryOrganization(){
            let res  = await api.QueryMechanism({page:this.organizationPage});
            console.log(res);
            this.organizationList = res.data.data.data;
            this.organizationTotalCount = res.data.data.totalCount;
        },
        // 删除角色
        deleteUser(row){
            console.log(row);
            let _this = this;
            this.$confirm('将删除选中的用户, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.deleteAsyncU(row.id);
                
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        async deleteAsyncU(id){
            let res = await api.DeleteAsyncU(id);
            if(res.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.selectData();
            }
        },


        //上传前做一些事
        async beforeUpload(file){
            console.log(file);
            // console.log(file.name);
            var msg=file.name.substring(file.name.lastIndexOf('.')+1)
            msg = msg.toLowerCase();
            if(msg != 'jpg' && msg != 'png' && msg != 'jpeg') {
                this.$message({
                    message: '上传文件只能是 jpg、png、jpeg格式!',
                    type: 'warning'
                });
                return false;
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        height: 100%;
        // overflow: scroll;
        .item{
            font-size: 14px;
            padding:8px 15px;
            display: flex;
            align-items: center;
            .label{
                width: 120px;
                margin-bottom: 5px;
            }
            .input{
                width: 215px;
                display: flex;
            }
        }
        .imglist{
            display: flex;
            flex-wrap: wrap;
            .pics-item{
                width: 100px;
                height: 100px;
                position: relative;
                margin: 15px;
                .img{
                    width: 100px;
                    height: 100px;
                    
                }
                .close{
                    position: absolute;
                    top: -12px;
                    right: -12px;
                    width: 24px;
                    height: 24px;
                }
            }
        }
        .btns{
            background-color: #ffffff;
            width: 100%;
            bottom: 0;
            display:flex;
            flex-direction: row-reverse;
            .el-button{
                margin-right: 10px;
            }
        }
    }
</style>
